<div class="" fxFlex="100">

  <!-- TOP BACKGROUND -->

    <div fxLayout="column" fxFlex="100" class="fondo">
      <div class="toolbar primary " fxLayout="row" fxLayoutAlign="space-between center">
        <span><h3 class="titulo_s">{{'CONTRO_ENCU.TIT_ENCABE' | translate}}</h3></span>
        <button mat-raised-button color="primary" (click)="filtroAbierto=!filtroAbierto">{{'CONTRO_ENCU.BTN_FIL_INFO' | translate}}<mat-icon>filter_list</mat-icon></button>
      </div>
      <div fxLayout="column" fxLayoutAlign="start start" class="tamañoCompleto">
              <mat-sidenav-container class="tamañoCompleto">
              <mat-sidenav mode="side" [(opened)]="filtroAbierto" position="end" class="tamañoMat-sidenav">
                <div class="" fxLayout="column" fxLayoutAlign="space-between start">
                  <mat-form-field appearance="outline" style="width:270px;margin-left:10px;margin-top:10px">
                  <mat-label>{{'CONTRO_ENCU.SELEC_INSTI' | translate}}</mat-label>
                  <mat-select [(ngModel)]="selectedInstituto" name="institutos">
                    <mat-option *ngFor="let institute of institutes" [value]="institute.numInstituto">
                      {{'PERFILES.EMPRESA.SECCIONES.SEC1.CATALOGOS.INSTITUTOS.'+institute.numInstituto | translate}}
                    </mat-option>
                  </mat-select>
                  <span class="material-icons-outlined">flag</span>
                </mat-form-field>
                  <mat-form-field appearance="outline" style="width:270px;margin-left:10px">
                  <mat-label>{{'CONTRO_ENCU.SELEC_YEA' | translate}}</mat-label>
                  <mat-select [(ngModel)]="selectedYears" name="years">
                    <mat-option *ngFor="let year of years" [value]="year.anio">
                      {{year.anio}}
                    </mat-option>
                  </mat-select>
                  <span class="material-icons-outlined">event</span>
                </mat-form-field>
                  <mat-form-field appearance="outline" style="width:270px;margin-left:10px">
                  <mat-label>{{'CONTRO_ENCU.SELEC_ESTA' | translate}}</mat-label>
                  <mat-select [(ngModel)]="selectedEsta" name="estatus">
                    <mat-option *ngFor="let esta of Estatus" [value]="esta.value">
                      {{esta.viewValue}}
                    </mat-option>
                  </mat-select>
                  <span class="material-icons-outlined">adjust</span>
                </mat-form-field>
                  <mat-form-field appearance="outline" style="width:270px;margin-left:10px">
                  <mat-label>{{'CONTRO_ENCU.SELEC_TI_ENC' | translate}}</mat-label>
                  <mat-select [(ngModel)]="selectedProduc" name="product">
                    <mat-option *ngFor="let producto of Productos" [value]="producto.idProducto">
                      {{'CONSULTATABLA.PRODUCTOS.'+producto.idProducto | translate}}
                    </mat-option>
                  </mat-select>
                  <span class="material-icons-outlined">format_list_bulleted</span>
                </mat-form-field>
                </div>
                 <div class="" fxLayout="row" fxLayoutAlign="center center">
                   <button mat-raised-button color="primary" (click)="filtrarInformacion()">{{'NOTIFICACION_PRODUCT.BUSCAR_FILTER'| translate}} <mat-icon>search</mat-icon></button>
                 </div>
                </mat-sidenav>


                <mat-sidenav-content class="tamañoCompleto">
                  <ng-container *ngIf="busquedaIniciada">
                    <ng-container *ngIf="cargando">
                      <div fxLayout="column" fxLayoutAlign="center center" >
                        <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                        <h1>{{'CONTRO_ENCU.CHAN_INFO' | translate}}</h1>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!cargando">
                      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table" matSort>
                        <ng-container matColumnDef="name">
                          <th mat-header-cell *matHeaderCellDef class="border" mat-sort-header> {{'CONTRO_ENCU.NAM_TH.TH_NAM' | translate}} </th>
                          <td mat-cell *matCellDef="let element" class="border"> {{element.name}} </td>
                        </ng-container>
                        <ng-container matColumnDef="type_survey">
                          <th mat-header-cell *matHeaderCellDef class="border"> {{'CONTRO_ENCU.NAM_TH.TH_TI_ENCU' | translate}} </th>
                          <td mat-cell *matCellDef="let element" class="border"> {{'CONSULTATABLA.PRODUCTOS.'+element.type_survey | translate}}</td>
                        </ng-container>
                        <ng-container matColumnDef="start_date">
                          <th mat-header-cell *matHeaderCellDef class="border" mat-sort-header> {{'CONTRO_ENCU.NAM_TH.TH_DAT_APLI' | translate}} </th>
                          <td mat-cell *matCellDef="let element" class="border"> {{element.start_date}} </td>
                        </ng-container>
                        <ng-container matColumnDef="id_status">
                          <th mat-header-cell *matHeaderCellDef class="border"> {{'CONTRO_ENCU.NAM_TH.TH_ESTA' | translate}} </th>
                          <td mat-cell *matCellDef="let element" class="border"> {{element.id_status[0]}} </td>
                        </ng-container>
                        <ng-container matColumnDef="token_config">
                          <th mat-header-cell *matHeaderCellDef class="border" mat-sort-header> {{'CONTRO_ENCU.NAM_TH.TH_TOKE' | translate}} </th>
                          <td mat-cell *matCellDef="let element" class="border"> {{element.token_config}} </td>
                        </ng-container>
                        <ng-container matColumnDef="HC">
                          <th mat-header-cell *matHeaderCellDef class="border"> {{'CONTRO_ENCU.NAM_TH.TH_HC' | translate}} </th>
                          <td mat-cell *matCellDef="let element" class="border"> {{element.HC}} </td>
                        </ng-container>
                        <ng-container matColumnDef="Respuestas">
                          <th mat-header-cell *matHeaderCellDef class="border" mat-sort-header> {{'CONTRO_ENCU.NAM_TH.TH_RESPU' | translate}} </th>
                          <td mat-cell *matCellDef="let element" class="border"> {{element.Respuestas}} </td>
                        </ng-container>
                        <ng-container matColumnDef="end_date">
                          <th mat-header-cell *matHeaderCellDef class="border"> {{'CONTRO_ENCU.NAM_TH.TH_DAT_CLO' | translate}} </th>
                          <td mat-cell *matCellDef="let element" class="border"> {{element.end_date}} </td>
                        </ng-container>
                        <ng-container matColumnDef="prorroga">
                          <th mat-header-cell *matHeaderCellDef class="border"> {{'CONTRO_ENCU.NAM_TH.TH_PRORR' | translate}} </th>
                          <td mat-cell *matCellDef="let element" class="border"> {{element.prorroga}}  </td>
                        </ng-container>
                        <ng-container matColumnDef="reporte_excel">
                          <th mat-header-cell *matHeaderCellDef class="border"> {{'CONTRO_ENCU.NAM_TH.TH_REPO_EXC' | translate}} </th>
                          <td mat-cell *matCellDef="let element;let i = index;" class="border">
                            <ng-container *ngIf="element.ReporteExcelText!=null">
                              <mat-checkbox class="checkbox" [(ngModel)]="element.ReporteExcel"(change)="reporte_excel($event.checked,element,i,1)" >
                              <div class="span">
                                <ng-container *ngFor="let history of element.ReporteExcelText2">
                                  <p class="p-margin">{{'CONTRO_ENCU.USE' | translate}}{{history.user}}</p>
                                  <p class="p-margin">{{'CONTRO_ENCU.DAT' | translate}} {{history.date}}</p>
                                  <p class="p-margin">{{'CONTRO_ENCU.ACC' | translate}} {{'CONTRO_ENCU.ACC_EVENT.'+history.tipo | translate}}</p>
                                  <mat-divider class=".mat-divider"></mat-divider>
                                </ng-container>
                              </div>
                            </mat-checkbox>
                            </ng-container>
                            <ng-container *ngIf="element.ReporteExcelText==null">
                              <mat-checkbox class="checkboxIncial" [(ngModel)]="element.ReporteExcel"  (change)="reporte_excel($event.checked,element,i,1)">
                              </mat-checkbox>
                            </ng-container>


                        </td>

                        </ng-container>

                        <ng-container matColumnDef="online">
                          <th mat-header-cell *matHeaderCellDef class="border"> {{'CONTRO_ENCU.NAM_TH.TH_ONLI' | translate}} </th>
                          <td mat-cell *matCellDef="let element;let a = index;" class="border">
                              <ng-container *ngIf="element.OnlineText!=null">
                             <mat-checkbox  class="checkbox" [(ngModel)]="element.Online" (change)="online($event.checked,element,a,2)">
                            <div  class="span">
                              <ng-container *ngFor="let history of element.OnlineText2">
                                <p class="p-margin">{{'CONTRO_ENCU.USE' | translate}}{{history.user}}</p>
                                <p class="p-margin">{{'CONTRO_ENCU.DAT' | translate}} {{history.date}}</p>
                                <p class="p-margin">{{'CONTRO_ENCU.ACC' | translate}} {{'CONTRO_ENCU.ACC_EVENT.'+history.tipo | translate}}</p>
                                <mat-divider class=".mat-divider"></mat-divider>
                              </ng-container>
                            </div>
                          </mat-checkbox>
                        </ng-container>
                        <ng-container *ngIf="element.OnlineText==null">
                          <mat-checkbox class="checkboxIncial" [(ngModel)]="element.Online"(change)="online($event.checked,element,a,2)" >
                          </mat-checkbox>
                        </ng-container>


                        </td>

                        </ng-container>

                        <ng-container matColumnDef="offline">
                          <th mat-header-cell *matHeaderCellDef class="border"> {{'CONTRO_ENCU.NAM_TH.TH_OFFLI' | translate}} </th>
                          <td mat-cell *matCellDef="let element;let b = index;" class="border">
                              <ng-container *ngIf="element.OfflineText!=null">
                            <mat-checkbox class="checkbox" [(ngModel)]="element.Offline" (change)="offline($event.checked,element,b,3)">
                            <div  class="span">
                              <ng-container *ngFor="let history of element.OfflineText2" >
                                <p class="p-margin">{{'CONTRO_ENCU.USE' | translate}}{{history.user}}</p>
                                <p class="p-margin">{{'CONTRO_ENCU.DAT' | translate}} {{history.date}}</p>
                                <p class="p-margin">{{'CONTRO_ENCU.ACC' | translate}} {{'CONTRO_ENCU.ACC_EVENT.'+history.tipo | translate}}</p>
                                <mat-divider class=".mat-divider"></mat-divider>
                              </ng-container>
                            </div>
                          </mat-checkbox>
                        </ng-container>
                        <ng-container *ngIf="element.OfflineText==null">
                          <mat-checkbox  [(ngModel)]="element.Offline"(change)="offline($event.checked,element,b,3)" >
                          </mat-checkbox>
                        </ng-container>

                        </td>

                        </ng-container>
                        <ng-container matColumnDef="auditoria">
                          <th mat-header-cell *matHeaderCellDef class="border"> {{'CONTRO_ENCU.NAM_TH.TH_AUDIT' | translate}} </th>
                          <td mat-cell *matCellDef="let element;let c = index;" class="border">
                            <ng-container *ngIf="element['AuditoríaText']!=null">
                            <mat-checkbox class="checkbox" [(ngModel)]="element['Auditoría']" (change)="AuditoriaUpd($event.checked,element,c,4)">
                              <ng-container *ngFor="let history of element['AuditoríaText2']">
                            <div  class="span">
                              <p class="p-margin">{{'CONTRO_ENCU.USE' | translate}}{{history.user}}</p>
                              <p class="p-margin">{{'CONTRO_ENCU.DAT' | translate}} {{history.date}}</p>
                              <p class="p-margin">{{'CONTRO_ENCU.ACC' | translate}} {{'CONTRO_ENCU.ACC_EVENT.'+history.tipo | translate}}</p>
                                <mat-divider class=".mat-divider"></mat-divider>
                            </div>
                          </ng-container>
                          </mat-checkbox>
                        </ng-container>
                        <ng-container *ngIf="element['AuditoríaText']==null">
                          <mat-checkbox  [(ngModel)]="element['Auditoría']" (change)="AuditoriaUpd($event.checked,element,c,4)" >
                          </mat-checkbox>
                        </ng-container>
                        </td>

                        </ng-container>
                        <ng-container matColumnDef="sector">
                          <th mat-header-cell *matHeaderCellDef class="border"> {{'CONTRO_ENCU.NAM_TH.TH_SECT' | translate}} </th>
                          <td mat-cell *matCellDef="let element" class="border"> {{element.sector}} </td>
                        </ng-container>
                        <ng-container matColumnDef="subsector">
                          <th mat-header-cell *matHeaderCellDef class="border"> {{'CONTRO_ENCU.NAM_TH.TH_SUBSECT' | translate}} </th>
                          <td mat-cell *matCellDef="let element" class="border"> {{element.subsector}} </td>
                        </ng-container>
                        <ng-container matColumnDef="emailResponsable">
                          <th mat-header-cell *matHeaderCellDef class="border"> {{'CONTRO_ENCU.NAM_TH.TH_LIPROY' | translate}} </th>
                          <td mat-cell *matCellDef="let element" class="border"> {{element.emailResponsable}} </td>
                        </ng-container>
                        <ng-container matColumnDef="project_manager">
                          <th mat-header-cell *matHeaderCellDef class="border"> {{'CONTRO_ENCU.NAM_TH.TH_JEFPROY' | translate}} </th>
                          <td mat-cell *matCellDef="let element" class="border"> {{element.project_manager}} </td>
                        </ng-container>


                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                      </table>

                    </ng-container>
              </ng-container>
              <ng-container *ngIf="!busquedaIniciada">
                <div  fxLayout="row" fxLayoutAlign="center center">
                  <h1 class="texto">{{'CONTRO_ENCU.TEX_INTRUCC' | translate}}</h1>

                </div>
              </ng-container>
                </mat-sidenav-content>
              </mat-sidenav-container>
          </div>
    </div>
  </div>
